import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {ServiceVersions, VersionInfo} from '../domain/cloud-topology';
import { HttpClient, HttpParams } from '@angular/common/http';
import { versionUrl, serviceUrl } from '../domain/constants';
import {AuthGuardService} from './auth-guard.service';
import {ResourceService} from './resource.service';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  constructor(private http: HttpClient) {}

  getServiceInfo():  Observable<ServiceVersions> {

    return this.http.get(ResourceService.buildUrl([serviceUrl])).pipe(map(res => res['data']));
  }
}
